// Handles term-based filtering for cards and descriptions
export const registerTermsSwitcher = function switchTerms() {
  const termBox = document.querySelector('.term-box')
  if (!termBox) return

  const termsBoxes = document.querySelectorAll('.term-box')
  const termsPosts = document.querySelectorAll('.term-post') // regular post cards
  const termsDescriptions = document.querySelectorAll('.term-description') // description containers
  const firstTermID = termsBoxes[0]?.dataset.term
  const urlParams = new URLSearchParams(window.location.search)
  const categoryId = urlParams.get('category_id')

  // Helper: does this term have any content at all?
  // (either a description container or at least one post card)
  const hasAnyContent = (termID) => {
    const hasDesc = Array.from(termsDescriptions).some(
      (d) => d.dataset.term === termID
    )
    const hasPost = Array.from(termsPosts).some((p) =>
      p.classList.contains(termID)
    )
    return hasDesc || hasPost
  }

  // Show BOTH description (if exists) AND posts for the selected term
  const showTermContent = (termID) => {
    // Hide everything first
    termsDescriptions.forEach((desc) => desc.classList.add('hidden'))
    termsPosts.forEach((post) => post.classList.add('hidden'))

    // Show description for this term (if exists)
    const descForTerm = Array.from(termsDescriptions).find(
      (d) => d.dataset.term === termID
    )
    if (descForTerm) descForTerm.classList.remove('hidden')

    // Show posts that belong to this term
    termsPosts.forEach((post) => {
      if (post.classList.contains(termID)) {
        post.classList.remove('hidden')
      }
    })
  }

  // Click handlers for buttons
  termsBoxes.forEach((box) => {
    box.addEventListener('click', () => {
      const termID = box.dataset.term

      // Update active state
      termsBoxes.forEach((b) => b.classList.remove('active'))
      box.classList.add('active')

      // Show both: description (if present) & posts
      showTermContent(termID)
    })
  })

  // Initial render based on URL param (?category_id=)
  if (categoryId && hasAnyContent(categoryId)) {
    // Set active button
    termsBoxes.forEach((box) => {
      if (box.dataset.term === categoryId) box.classList.add('active')
      else box.classList.remove('active')
    })

    // Show content for URL category
    showTermContent(categoryId)
  } else {
    // Default: activate the first term with content, else fallback to very first
    const firstWithContent =
      Array.from(termsBoxes).find((b) => hasAnyContent(b.dataset.term)) ||
      termsBoxes[0]

    if (firstWithContent) {
      firstWithContent.classList.add('active')
      showTermContent(firstWithContent.dataset.term)
    }
  }
}
